"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["children", "name"],
  _excluded2 = ["component"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var RadioGroup = /*#__PURE__*/function (_React$PureComponent) {
  function RadioGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, RadioGroup);
    _this = _callSuper(this, RadioGroup, [props]);
    _this.state = {
      selected: props.selected
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(RadioGroup, _React$PureComponent);
  return (0, _createClass2["default"])(RadioGroup, [{
    key: "handleChange",
    value: function handleChange(ev) {
      this.setState({
        selected: ev.detail.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var selected = this.state.selected;
      return /*#__PURE__*/_react["default"].createElement(StyledRadioGroup, props, _react["default"].Children.map(children, function (child) {
        return /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          key: child.props.value === selected,
          name: name,
          component: child,
          value: child.props.value,
          changeVal: _this2.handleChange,
          checked: child.props.value === selected
        });
      }));
    }
  }]);
}(_react["default"].PureComponent);
RadioGroup.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  selected: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
RadioGroup.defaultProps = {
  className: '',
  selected: null,
  onChange: Function.prototype
};
var StyledRadioGroup = _styledComponents["default"].div.withConfig({
  displayName: "RadioGroup__StyledRadioGroup",
  componentId: "sc-a0jxwg-0"
})([""]);
var StyledRadio = (0, _styledComponents["default"])(function (_ref) {
  var component = _ref.component,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
  return /*#__PURE__*/_react["default"].cloneElement(component, props);
}).withConfig({
  displayName: "RadioGroup__StyledRadio",
  componentId: "sc-a0jxwg-1"
})([""]);
var _default = exports["default"] = RadioGroup;